import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";

import { SelectItem } from "@skailer-com/uikit";

export interface ApiDepartmentShort extends SelectItem {
  id: number;
  title: string;
  is_archived: boolean;
}

export interface ApiEmployeeDepartment extends SelectItem {
  id: number;
  title: string;
  is_archived: boolean;
  manager?: ApiEmployee;
  image_url?: string;
  emoji?: string;
}

export interface ApiDepartment extends SelectItem {
  id: number;
  emoji: string | null;
  image_url?: string;
  title: string;

  employees_count: number;

  manager: ApiEmployee | null;
  parent_id: number | null;

  direct_subordinates_count: number;
}

export interface ApiDepartmentFilter extends ApiFilterBase {
  text?: string;
}

export interface ApiDepartmentSavePayload {
  title: string;
  manager_id: number | null;
  parent_id: number | null;
  emoji: string | null;
  image_file_uuid?: string | null;
  assign_manager_to_subordinates: boolean;
}

export enum DepartmentNodeMode {
  parent = "parent",
  children = "children",
}
export const buildDepartmentTree = (departments: ApiDepartment[]) => {
  const departmentMap = new Map<number, ApiDepartment>();
  const rootDepartments: ApiDepartment[] = [];

  departments.forEach((dept) => {
    departmentMap.set(dept.id, dept);
    if (dept.parent_id === null) {
      rootDepartments.push(dept);
    }
  });

  const addDepartmentWithChildren = (
    department: ApiDepartment,
    level: number = 0
  ): ApiDepartment[] => {
    const result: ApiDepartment[] = [];

    result.push({
      ...department,
      level: level,
    });

    const children = departments.filter((dept) => dept.parent_id === department.id);
    children
      .sort((a, b) => a.title.localeCompare(b.title))
      .forEach((child) => {
        result.push(...addDepartmentWithChildren(child, level + 1));
      });

    return result;
  };

  const treeResult: ApiDepartment[] = [];
  rootDepartments
    .sort((a, b) => a.title.localeCompare(b.title))
    .forEach((rootDept) => {
      treeResult.push(...addDepartmentWithChildren(rootDept));
    });

  return treeResult;
};
